import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Eye",
  "use": "Eye-usage",
  "viewBox": "0 0 20 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 12\" id=\"Eye\"><g fill-rule=\"evenodd\"><circle cx=\"9.764\" cy=\"5.938\" r=\"3.125\" /><path d=\"M.008 5.938A.238.238 0 0 1 0 5.883h.024c.531-1.5 9.765-12.485 19.31.054h.041l-.02.028.02.027h-.041c-9.545 12.54-18.78 1.503-19.31 0H0c0-.015.003-.033.008-.054zm2.492 0h14.375C10 14.688 2.5 6.68 2.5 5.938zm0-.004h14.375C10-2.816 2.5 5.191 2.5 5.934z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol